import { render, staticRenderFns } from "./productBalanceAssets.vue?vue&type=template&id=0e620950&scoped=true&"
import script from "./productBalanceAssets.vue?vue&type=script&lang=js&"
export * from "./productBalanceAssets.vue?vue&type=script&lang=js&"
import style0 from "./productBalanceAssets.vue?vue&type=style&index=0&id=0e620950&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e620950",
  null
  
)

export default component.exports